import { useState } from 'react';

import nextIcon from '../../../assets/images/nextIcon.svg';
import { getOwnerBalanceThunk, payThunk } from '../../../store/slices/paymentsSlice';
import { closePopup, openPopup } from '../../../store/slices/popupSlice';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import {
  formatCurrency,
  parseAmountForCP,
  waitAndUpdateBalance,
} from '../../../utils/functions';
import BankCardItem from '../../BankCardItem/BankCardItem';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function PaymentMethodsPopup() {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const cards = useAppSelector((state) => state.cards.cards);
  // const publicIdCP = process.env.REACT_APP_CLOUD_PAYMENTS_PUBLIC_ID;
  const user = useAppSelector((state) => state.user.data);
  const isLegalEntity = user.type !== 'individual';
  // const isLegalEntity = true;
  // const [isLegalEntity, setLegalEntity] = useState(true);

  const popupProps = useAppSelector((state) => state.popup.popupProps);
  const context = popupProps?.context;

  // Внутри компонента
  const rawAmount = popupProps?.amount; // извлекаем сразу
  const amount = parseAmountForCP(rawAmount);
  const costMonthlyRate = parseAmountForCP(popupProps?.monthlyRate);

  console.log(amount, costMonthlyRate, context);
  const [selectedCardId, setSelectedCardId] = useState(
    cards.length !== 0 ? cards[0]?.id : null
  );

  const handleInvoicePopupOpen = () => {
    dispatch(
      openPopup({
        name: 'invoice',
        props: {
          total: amount,
          services: context === 'services' ? 'services' : 'storage',
          monthlyRate: costMonthlyRate,
        },
      })
    );
  };

  const handleClosePopup = () => {
    dispatch(closePopup());
  };

  const handleSubmit = () => {
    if (!selectedCardId) return;
    if (selectedCardId === 'other') {
      dispatch(
        openPopup({
          name: 'otherPayments',
          props: {
            amount,
            context,
          },
        })
      );
    } else if (selectedCardId === 'receipt') {
      handleInvoicePopupOpen();
    } else {
      setLoading(true);
      dispatch(
        payThunk({
          method_id: selectedCardId,
          amount,
          pay_type: context === 'services' ? 'services' : 'storage', // services или storage
        })
      )
        .unwrap()
        .then((res) => {
          setLoading(false);
          console.log('Оплата прошла ✅', res);
          dispatch(openPopup('topUpSuccess'));
          dispatch(getOwnerBalanceThunk(user.id));
          const ok = waitAndUpdateBalance(user.id, dispatch, 10);
          if (ok) dispatch(closePopup('otherPayments'));
          else console.warn('⚠ Баланс не обновился вовремя');
          dispatch(closePopup('paymentMethods'));
        })
        .catch((err) => {
          setLoading(false);
          console.log('Ошибка при оплате ❌', err);
          dispatch(openPopup('topUpFail'));
        });
    }
  };

  return (
    <div className={styles.paymentPopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          marginBottom: '16px',
        }}
      >
        <h2 className={styles.paymentPopupTitle}>Способ оплаты</h2>
        <h3 style={{ fontSize: '12px', color: '#626A73', fontWeight: '400' }}>
          Сумма к оплате {formatCurrency(amount)} ₽
        </h3>
      </div>
      <div className={styles.paymentPopupContainer}>
        <div className={styles.paymentPopupCardsContainer}>
          {cards.map((card) => (
            <BankCardItem
              key={card.id}
              card={card}
              isSelected={selectedCardId === card.id}
              onSelectCard={() => setSelectedCardId(card.id)}
            />
          ))}
          <button
            className={`${styles.paymentButton} ${selectedCardId === 'other' ? styles.paymentButton_selected : ''}`}
            type="button"
            onClick={() => setSelectedCardId('other')}
          >
            <span>Другим способом</span>
            <img className={styles.paymentButtonImg} src={nextIcon} alt="иконка вперед" />
          </button>
          {isLegalEntity ? (
            <button
              className={`${styles.paymentButtonInvice} ${selectedCardId === 'receipt' ? styles.paymentButton_selected : ''}`}
              type="button"
              onClick={() => setSelectedCardId('receipt')}
            >
              <span>Сформировать счёт</span>
              <img
                className={styles.paymentButtonImg}
                src={nextIcon}
                alt="иконка вперед"
              />
            </button>
          ) : null}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <RedButton
            text={context === 'topUp' ? 'Пополнить' : 'Оплатить'}
            height={50}
            disabled={!selectedCardId}
            onClick={handleSubmit}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
}

export default PaymentMethodsPopup;
